export enum PlaybookType {
  DocumentRequest = 'document_request',
  Interview = 'interview',
  MatchDecision = 'match_decision',
  MatchFlow = 'match_flow',
  Objection = 'objection',
  Other = 'other',
}

export const I18N_PLAYBOOK_TYPE = {
  [PlaybookType.DocumentRequest]: 'Dokumentenanfrage',
  [PlaybookType.Interview]: 'Interview',
  [PlaybookType.MatchDecision]: 'Match-Entscheidung',
  [PlaybookType.MatchFlow]: 'Match-Ablauf',
  [PlaybookType.Objection]: 'Einwand',
  [PlaybookType.Other]: 'Sonstiges',
};

export enum PlaybookPhase {
  Matchmail = 'matchmail',
  PreVt = 'pre_vt',
  PostVt = 'post_vt',
  PostHt = 'post_ht',
}

export const I18N_PLAYBOOK_PHASE = {
  [PlaybookPhase.Matchmail]: 'Matchmail',
  [PlaybookPhase.PreVt]: 'Vor VT',
  [PlaybookPhase.PostVt]: 'Nach VT',
  [PlaybookPhase.PostHt]: 'Nach HT',
};
